import { Button, ComboBox, Icons, WideAlert } from '@components';
import { mdiCommentAlertOutline } from '@mdi/js';
import { CaminhosPDFService } from '@services';
import getYear from 'date-fns/getYear';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const InformeRendimentosPage = () => {
  const user = useSelector((state) => state.user);
  const custom = useSelector((state) => state.customizaSistema);
  const [semResultados, setSemResultados] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(true);
  const [anoSelecionado, setAnoSelecionado] = useState('');
  const navigate = useNavigate();
  const opcoesAnos = () => {
    const anos = [];
    for (
      // regra definida foi quando o ano DIB for menor que 2018, o ano inicial será 2018
      let i =
        Number(user.DIB.split('/')[2]) < 2018
          ? 2018
          : Number(user.DIB.split('/')[2]);
      i < getYear(new Date());
      i += 1
    ) {
      anos.push(i.toString());
    }
    return anos.sort((a, b) => {
      return b.localeCompare(a);
    });
  };

  useEffect(() => {
    if (anoSelecionado !== '') setHabilitarBotao(false);
  }, [anoSelecionado]);

  const gerarPDF = () => {
    const caminhosPDFService = new CaminhosPDFService();

    caminhosPDFService
      .getInformeRendimento(user.matricula, user.token, anoSelecionado)
      .then((res) => {
        if (res.data.msgConsistencia) setSemResultados(true);
        else {
          const mimeType = res.headers['content-type'];
          const blob = new Blob([res.data], { type: mimeType });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Informe de rendimentos ${anoSelecionado}- ${user.matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch(() => {
        toast.error('Erro ao carregar o arquivo.');
      })
      .finally(() => {});
  };

  return (
    <>
      <Helmet>
        <title>Forluz - Informe Anual de Rendimentos</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Informe Anual de Rendimentos</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <h2>
            <strong>{user.matricula}</strong> - {user.dadosPessoais.nome}
          </h2>
          {semResultados && (
            <WideAlert className="mb-4 mt-4" iconClear={false}>
              <div className="d-block d-lg-flex align-items-center">
                <Icons
                  path={mdiCommentAlertOutline}
                  color="var(--primary-color)"
                  size={2}
                  style={{ marginRight: 4 }}
                />
                <p className="ts-16">
                  <strong>Aviso importante:</strong> Não foi encontrato informe
                  de rendimento para o ano escolhido.
                </p>
              </div>
            </WideAlert>
          )}
          <div className="row col-12 col-md-8 col-lg-6 mb-4 mt-4">
            <ComboBox
              color={custom.nomeCorPrincipal}
              label="Ano"
              className="mt-3 col-12 col-md6 col-lg-6"
              defaultValue={anoSelecionado}
              values={anoSelecionado}
              onChange={setAnoSelecionado}
              tooltip="Selecione o ano de referência"
              options={opcoesAnos().map((x) => {
                return { value: x, label: x };
              })}
            />
            <Button
              className="mt-4 col-2 col-lg-3"
              disabled={habilitarBotao}
              onClick={gerarPDF}
            >
              Gerar informe de rendimentos
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
